module.exports = __webpack_public_path__ + "img/3_de.0efececd.jpg";